import { visionLabApi } from '@/app/apiClient';
import type { ApiCallOptions } from '@/shared/api/client';

export interface QualityCheckResponse {
  qualityCheckId: string;
  status: 'accepted' | 'rejected';
  facts: {
    hasVideo: boolean;
    fps: number;
    bitrateKbps: number;
    durationSecs: number;
    pixels: number;
  };
}

export async function checkVideoQuality(
  projectId: string,
  evidence: ArrayBuffer,
  options: ApiCallOptions = {},
): Promise<QualityCheckResponse> {
  return visionLabApi.post<QualityCheckResponse>(
    `/projects/${encodeURIComponent(projectId)}/quality-check`,
    {
      ...options,
      headers: { 'Content-Type': 'application/vnd.vision-lab.quality-evidence' },
      body: evidence,
    },
  );
}
